import { useSetAtom } from "jotai";
import { useCallback } from "react";
import { CabinNoiseData, EachConditionData, NullableFloatArray, setEachConditionDataAtom } from "atoms/Rtool/cabinAtoms";
import { CABIN_NOISE_EACH_IDS } from "utils/consts";

type Status = 'notstarted' | 'loading' | 'success' | 'error';

/** null 許容 float 配列のショートハンド */
const E: NullableFloatArray = [];

/** 空の allConditionData を返すユーティリティ */
export function createEmptyAllConditionData(
    conditionIds: string[],
    initialStatus: Status = 'loading'
): Record<string, CabinNoiseData> {
    return conditionIds.reduce<Record<string, CabinNoiseData>>((acc, id) => {
        acc[id] = {
            data: { cabin_noise_target: [], cabin_noise_pred: [], vel: [], rpm: [] },
            status: initialStatus,
        };
        return acc;
    }, {});
};

export function useResetEachConditionData(initialStatus: Status = 'loading') {
    const resetAll = useSetAtom(setEachConditionDataAtom);

    return useCallback(() => {
        const payload: EachConditionData[] = CABIN_NOISE_EACH_IDS.map((graph_id) => ({
            graph_id,
            data: E,
            status: initialStatus,
        }))

        resetAll(...payload)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [resetAll])
};
